import { SiProbot } from "react-icons/si";
import { FiCheckCircle, FiArrowRight, FiZap } from "react-icons/fi";

const AnaliseDeCreditoBanner = ({ onClick }) => {
  const beneficios = [
    "Parecer técnico completo",
    "Identifica riscos ocultos",
    "Decisões mais seguras",
  ];

  return (
    <div className="relative overflow-hidden rounded-3xl border border-[#66B7A2]/40 bg-gradient-to-br from-white via-[#F3FAF8] to-[#E6F4F0]">
      {/* Detalhes decorativos de fundo */}
      <div className="pointer-events-none absolute -right-16 -top-16 h-56 w-56 rounded-full bg-[#66B7A2]/15 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-20 left-1/4 h-40 w-40 rounded-full bg-[#66B7A2]/10 blur-3xl" />

      <div className="relative flex flex-col gap-6 p-6 sm:p-7 lg:flex-row lg:items-center lg:justify-between">
        {/* Lado esquerdo: ícone + texto */}
        <div className="flex items-start gap-5">
          <div className="space-y-2">
            <h3 className="text-lg font-bold text-[#1F3A33] sm:text-xl">
              Decida com segurança e inteligência
            </h3>

            <p className="max-w-xl text-sm leading-relaxed text-[#3B6258]">
              Ative agora a análise de crédito e receba um parecer
              técnico completo. Ideal para entender riscos, evitar prejuízos e
              tomar decisões melhores.
            </p>

            <ul className="flex flex-wrap gap-x-5 gap-y-1.5 pt-1">
              {beneficios.map((item) => (
                <li
                  key={item}
                  className="flex items-center gap-1.5 text-sm font-medium text-[#2D4D44]"
                >
                  <FiCheckCircle className="h-4 w-4 text-[#66B7A2]" />
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Lado direito: preço + botão */}
        <div className="flex shrink-0 flex-col items-stretch gap-3 lg:items-end">
          <div className="flex items-baseline gap-1.5 lg:justify-end">
            <span className="text-sm text-[#3B6258]">por apenas</span>
            <span className="text-2xl font-extrabold text-[#2D4D44]">
              R$ 1,50
            </span>
          </div>

          <button
            onClick={onClick}
            className="group inline-flex items-center justify-center gap-2 rounded-xl bg-gradient-to-r from-[#66B7A2] to-[#4E9A87] px-6 py-3 text-sm font-semibold text-white shadow-lg shadow-[#66B7A2]/30 transition-all duration-200 hover:-translate-y-0.5 hover:shadow-xl hover:shadow-[#66B7A2]/40 focus:outline-none focus:ring-2 focus:ring-[#66B7A2] focus:ring-offset-2"
          >
            Ver análise
            <FiArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-1" />
          </button>

          <p className="text-center text-xs text-[#3B6258]/80 lg:text-right">
            Resultado em segundos
          </p>
        </div>
      </div>
    </div>
  );
};

export default AnaliseDeCreditoBanner;
